import webgazer from './webgazer/src/';

const startGazeTracking = (obj) => {
    webgazer.showVideo(false);
    webgazer.showVideoPreview(false);
    webgazer.showPredictionPoints(false);
    webgazer.setGazeListener(function(data, elapsedTime) {
        if (data == null) {
            return;
        }
        // console.log(elapsedTime, data.x, data.y); //elapsed time is based on time since begin was called
        const coord = {x: data.x, y: data.y}
        //obj.setState({ gazeData: [...obj.currGazeData, coord] })
        obj.currGazeData.push(coord)
    }).begin();
};

const gaze = {
    "startGazeTracking": startGazeTracking
}

export { gaze }